import { usePricingOptions } from "routes/data-routes/billing-data/pricing-options";
import { PricingOptionsDataRoutePath } from "routes/data-routes/billing-data/pricing-options/route.meta";


export function useAutoUpgradeToggleAction() {
  const { pricingOptionsFetcher } = usePricingOptions();

  return (autoUpgrade: boolean) => {
    const formData = new FormData();
    formData.append("pricing-option-action", "auto-upgrade");
    formData.append("auto-upgrade", autoUpgrade.toString());
    pricingOptionsFetcher.submit(formData, { method: "POST", action: PricingOptionsDataRoutePath });
  }
}
